// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as UserAgent from "../../primitives/UserAgent.res.js";
import * as AuthRoutes from "./AuthRoutes.res.js";
import * as BugTracker from "../../core/BugTracker.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as Auth__Types from "../../bundles/Auth/Auth__Types.res.js";
import * as CountryCode from "../../primitives/CountryCode.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as SpinnerModal from "../../resources/feedback-indicators/SpinnerModal.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ScrollHelpers from "../../helpers/ScrollHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import Wino_logoPng from "./wino_logo.png";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as CorporateEntity from "../../core/CorporateEntity.res.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as SiretInputField from "../../modules/SiretInputField.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Form__Submission from "../../bundles/Form/Form__Submission.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CompanyLegalNumber from "../../modules/CompanyLegalNumber.res.js";
import * as ElectronicInvoicing from "../../modules/ElectronicInvoicing/ElectronicInvoicing.res.js";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as AddressComboBoxField from "../../modules/AddressComboBoxField.res.js";
import * as CompanyComboBoxField from "../../modules/CompanyComboBoxField.res.js";
import * as PageBottomActionsBar from "../../resources/layout-and-structure/PageBottomActionsBar.res.js";
import * as FiscalYearOpeningMonth from "../../modules/FiscalYearOpeningMonth.res.js";
function get(values, field) {
  switch (field) {
    case "Username":
      return values.username;
    case "Password":
      return values.password;
    case "PasswordConfirmation":
      return values.passwordConfirmation;
    case "Name":
      return values.name;
    case "Email":
      return values.email;
    case "PhoneNumber":
      return values.phoneNumber;
    case "Kind":
      return values.kind;
    case "FrenchCompany":
      return values.frenchCompany;
    case "CorporateName":
      return values.corporateName;
    case "LegalRepresentative":
      return values.legalRepresentative;
    case "LegalForm":
      return values.legalForm;
    case "EmployeesNumber":
      return values.employeesNumber;
    case "TaxationRegime":
      return values.taxationRegime;
    case "FiscalYearEndClosingMonth":
      return values.fiscalYearEndClosingMonth;
    case "Website":
      return values.website;
    case "AmountOfShareCapital":
      return values.amountOfShareCapital;
    case "SiretNumber":
      return values.siretNumber;
    case "RcsNumber":
      return values.rcsNumber;
    case "ApeNafCode":
      return values.apeNafCode;
    case "VatNumber":
      return values.vatNumber;
    case "Address":
      return values.address;
    case "City":
      return values.city;
    case "PostalCode":
      return values.postalCode;
    case "Country":
      return values.country;
    case "BankName":
      return values.bankName;
    case "BankCode":
      return values.bankCode;
    case "BankAccountHolder":
      return values.bankAccountHolder;
    case "BankAccountNumber":
      return values.bankAccountNumber;
    case "BicCode":
      return values.bicCode;
    case "IbanNumber":
      return values.ibanNumber;
  }
}
function set(values, field, value) {
  switch (field) {
    case "Username":
      let newrecord = {
        ...values
      };
      newrecord.username = value;
      return newrecord;
    case "Password":
      let newrecord$1 = {
        ...values
      };
      newrecord$1.password = value;
      return newrecord$1;
    case "PasswordConfirmation":
      let newrecord$2 = {
        ...values
      };
      newrecord$2.passwordConfirmation = value;
      return newrecord$2;
    case "Name":
      let newrecord$3 = {
        ...values
      };
      newrecord$3.name = value;
      return newrecord$3;
    case "Email":
      let newrecord$4 = {
        ...values
      };
      newrecord$4.email = value;
      return newrecord$4;
    case "PhoneNumber":
      let newrecord$5 = {
        ...values
      };
      newrecord$5.phoneNumber = value;
      return newrecord$5;
    case "Kind":
      let newrecord$6 = {
        ...values
      };
      newrecord$6.kind = value;
      return newrecord$6;
    case "FrenchCompany":
      let newrecord$7 = {
        ...values
      };
      newrecord$7.frenchCompany = value;
      return newrecord$7;
    case "CorporateName":
      let newrecord$8 = {
        ...values
      };
      newrecord$8.corporateName = value;
      return newrecord$8;
    case "LegalRepresentative":
      let newrecord$9 = {
        ...values
      };
      newrecord$9.legalRepresentative = value;
      return newrecord$9;
    case "LegalForm":
      let newrecord$10 = {
        ...values
      };
      newrecord$10.legalForm = value;
      return newrecord$10;
    case "EmployeesNumber":
      let newrecord$11 = {
        ...values
      };
      newrecord$11.employeesNumber = value;
      return newrecord$11;
    case "TaxationRegime":
      let newrecord$12 = {
        ...values
      };
      newrecord$12.taxationRegime = value;
      return newrecord$12;
    case "FiscalYearEndClosingMonth":
      let newrecord$13 = {
        ...values
      };
      newrecord$13.fiscalYearEndClosingMonth = value;
      return newrecord$13;
    case "Website":
      let newrecord$14 = {
        ...values
      };
      newrecord$14.website = value;
      return newrecord$14;
    case "AmountOfShareCapital":
      let newrecord$15 = {
        ...values
      };
      newrecord$15.amountOfShareCapital = value;
      return newrecord$15;
    case "SiretNumber":
      let newrecord$16 = {
        ...values
      };
      newrecord$16.siretNumber = value;
      return newrecord$16;
    case "RcsNumber":
      let newrecord$17 = {
        ...values
      };
      newrecord$17.rcsNumber = value;
      return newrecord$17;
    case "ApeNafCode":
      let newrecord$18 = {
        ...values
      };
      newrecord$18.apeNafCode = value;
      return newrecord$18;
    case "VatNumber":
      let newrecord$19 = {
        ...values
      };
      newrecord$19.vatNumber = value;
      return newrecord$19;
    case "Address":
      let newrecord$20 = {
        ...values
      };
      newrecord$20.address = value;
      return newrecord$20;
    case "City":
      let newrecord$21 = {
        ...values
      };
      newrecord$21.city = value;
      return newrecord$21;
    case "PostalCode":
      let newrecord$22 = {
        ...values
      };
      newrecord$22.postalCode = value;
      return newrecord$22;
    case "Country":
      let newrecord$23 = {
        ...values
      };
      newrecord$23.country = value;
      return newrecord$23;
    case "BankName":
      let newrecord$24 = {
        ...values
      };
      newrecord$24.bankName = value;
      return newrecord$24;
    case "BankCode":
      let newrecord$25 = {
        ...values
      };
      newrecord$25.bankCode = value;
      return newrecord$25;
    case "BankAccountHolder":
      let newrecord$26 = {
        ...values
      };
      newrecord$26.bankAccountHolder = value;
      return newrecord$26;
    case "BankAccountNumber":
      let newrecord$27 = {
        ...values
      };
      newrecord$27.bankAccountNumber = value;
      return newrecord$27;
    case "BicCode":
      let newrecord$28 = {
        ...values
      };
      newrecord$28.bicCode = value;
      return newrecord$28;
    case "IbanNumber":
      let newrecord$29 = {
        ...values
      };
      newrecord$29.ibanNumber = value;
      return newrecord$29;
  }
}
let SignupFormLenses_ = {
  get: get,
  set: set
};
let SignupFormLenses = {
  get: get,
  set: set
};
let SignupForm = Form.Make(SignupFormLenses);
function stripEmptyString(string) {
  if (string === "") {
    return;
  } else {
    return string;
  }
}
function createUserRegistrationPayloadDict(username, password, name, email, phoneNumber, kind, corporateName, legalRepresentative, legalForm, siretNumber, rcsNumber, apeNafCode, vatNumber, address, postalCode, city, country, website, amountOfShareCapital, fiscalYearEndClosingMonth, taxationRegime, employeesNumber, bankName, bankCode, bankAccountHolder, bankAccountNumber, bicCode, ibanNumber, ipAddress, userAgent, acceptedAt) {
  let shop = Object.fromEntries([["name", Json.encodeString(name)], ["email", Json.encodeString(email)], ["phoneNumber", Json.encodeString(phoneNumber)], ["type", Json.encodeString(Auth__Types.ShopKind.toString(kind))], ["corporateName", Json.encodeString(corporateName)], ["legalRepresentative", Json.encodeString(legalRepresentative)], ["legalForm", Json.encodeString(legalForm)], ["taxCountry", Json.encodeString(CountryCode.toIso2String(country))], ["address", Json.encodeString(address)], ["city", Json.encodeString(city)], ["postalCode", Json.encodeString(postalCode)], ["country", Json.encodeString(CountryCode.toMediumCountryString(country))], ["ibanNumber", Json.encodeString(ibanNumber)], ["shopName", Json.encodeString(name)], ["fiscalYearEndClosingMonth", Json.encodeString(fiscalYearEndClosingMonth)], ["taxationRegime", Json.encodeString(taxationRegime)], ["employeesNumber", Json.encodeString(employeesNumber)], ["bankName", Json.encodeString(bankName)], ["bankAccountHolder", Json.encodeString(bankAccountHolder)], ["bicCode", Json.encodeString(bicCode)], ["billingAccount", Json.encodeDict(Object.fromEntries([["corporateName", Json.encodeString(corporateName)], ["shopName", Json.encodeString(name)], ["phone", Json.encodeString(phoneNumber)], ["email", Json.encodeString(email)], ["vatNumber", Json.encodeString(Stdlib_Option.getOr(vatNumber, ""))], ["ibanNumber", Json.encodeString(ibanNumber)], ["billingAddress", Json.encodeDict(Object.fromEntries([["address", Json.encodeString(address)], ["city", Json.encodeString(city)], ["postalCode", Json.encodeString(postalCode)], ["country", Json.encodeString(CountryCode.toIsoString(country))]]))], ["shippingAddress", Json.encodeDict(Object.fromEntries([["address", Json.encodeString(address)], ["city", Json.encodeString(city)], ["postalCode", Json.encodeString(postalCode)], ["country", Json.encodeString(CountryCode.toIsoString(country))]]))], ["sepaMandateAcceptanceDetails", Json.encodeDict(Object.fromEntries([["ipAddress", Json.encodeString(ipAddress)], ["userAgent", Json.encodeString(userAgent)], ["acceptedAt", Json.encodeNumber(acceptedAt)]]))]]))]]);
  if (siretNumber !== undefined) {
    shop["siretNumber"] = Json.encodeString(siretNumber);
  }
  if (rcsNumber !== undefined) {
    shop["rcsNumber"] = Json.encodeString(rcsNumber);
  }
  if (apeNafCode !== undefined) {
    shop["apeNafCode"] = Json.encodeString(apeNafCode);
  }
  if (vatNumber !== undefined) {
    shop["vatNumber"] = Json.encodeString(vatNumber);
  }
  if (website !== undefined) {
    shop["website"] = Json.encodeString(website);
  }
  if (amountOfShareCapital !== undefined) {
    shop["amountOfShareCapital"] = Json.encodeString(amountOfShareCapital);
  }
  if (bankCode !== undefined) {
    shop["bankCode"] = Json.encodeString(bankCode);
  }
  if (bankAccountNumber !== undefined) {
    shop["bankAccountNumber"] = Json.encodeString(bankAccountNumber);
  }
  return Object.fromEntries([["username", Json.encodeString(username)], ["password", Json.encodeString(password)], ["shop", Json.encodeDict(shop)]]);
}
function decodeInvalidRequestFailure(serverFailure) {
  switch (serverFailure.kind) {
    case "DuplicateUserUsername":
      return "DuplicateUserUsername";
    case "InvalidCorporateName":
      return "InvalidCorporateName";
    case "InvalidIban":
      return "InvalidIban";
    case "InvalidVatNumber":
      return "InvalidVatNumber";
    case "WrongSepaMandateAcceptanceDetails":
      return "WrongSepaMandateAcceptanceDetails";
    default:
      return "Unknown";
  }
}
let endpoint = Env.gatewayUrl() + "/sign-up";
function make(username, password, name, email, phoneNumber, kind, corporateName, legalRepresentative, legalForm, siretNumber, rcsNumber, apeNafCode, vatNumber, address, postalCode, city, country, website, amountOfShareCapital, fiscalYearEndClosingMonth, taxationRegime, employeesNumber, bankName, bankCode, bankAccountHolder, bankAccountNumber, bicCode, ibanNumber, ipAddress, userAgent, acceptedAt) {
  return Future.mapError(Future.mapOk(Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: Json.encodeDict(createUserRegistrationPayloadDict(username, password, name, email, phoneNumber, kind, corporateName, legalRepresentative, legalForm, stripEmptyString(siretNumber), stripEmptyString(rcsNumber), stripEmptyString(apeNafCode), stripEmptyString(vatNumber), address, postalCode, city, country, stripEmptyString(website), stripEmptyString(amountOfShareCapital), fiscalYearEndClosingMonth, taxationRegime, employeesNumber, bankName, stripEmptyString(bankCode), bankAccountHolder, stripEmptyString(bankAccountNumber), bicCode, ibanNumber, ipAddress, userAgent, acceptedAt))
  }, false, undefined), undefined, param => {}), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return;
    } else {
      return Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure);
    }
  });
}
let SignupRequest = {
  createUserRegistrationPayloadDict: createUserRegistrationPayloadDict,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  endpoint: endpoint,
  make: make
};
function AuthSignupPage$NotificationBanner(props) {
  let notification = props.notification;
  let match;
  match = notification.TAG === "Ok" ? ["success", notification._0] : ["danger", notification._0];
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(NextBanner.make, {
      children: JsxRuntime.jsx(NextBanner.Text.make, {
        text: match[1]
      }),
      variation: match[0]
    }),
    spaceTop: "medium"
  });
}
let make$1 = React.memo(AuthSignupPage$NotificationBanner);
let NotificationBanner = {
  make: make$1
};
let schema = [{
  TAG: "Email",
  _0: "Username"
}, {
  TAG: "Password",
  _0: "Password"
}, {
  TAG: "StringNotEmpty",
  _0: "PasswordConfirmation"
}, {
  TAG: "CustomString",
  _0: "PasswordConfirmation",
  _1: (value, values) => {
    if (values.password === value) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("Password and its confirmation must be identical")
      };
    }
  }
}, {
  TAG: "StringNotEmpty",
  _0: "Name"
}, {
  TAG: "StringNotEmpty",
  _0: "LegalForm"
}, {
  TAG: "OptionDefined",
  _0: "EmployeesNumber"
}, {
  TAG: "OptionDefined",
  _0: "TaxationRegime"
}, {
  TAG: "OptionDefined",
  _0: "FiscalYearEndClosingMonth"
}, {
  TAG: "StringNotEmpty",
  _0: "BankName"
}, {
  TAG: "StringNotEmpty",
  _0: "BankAccountHolder"
}, {
  TAG: "StringNotEmpty",
  _0: "BicCode"
}, {
  TAG: "Email",
  _0: "Email"
}, {
  TAG: "PhoneNumber",
  _0: "PhoneNumber"
}, {
  TAG: "CustomString",
  _0: "CorporateName",
  _1: (value, param) => {
    if (CorporateEntity.CorporateName.validate(value)) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("The corporate name is invalid. Please provide the full name of the company.")
      };
    }
  }
}, {
  TAG: "StringNotEmpty",
  _0: "Address"
}, {
  TAG: "StringNotEmpty",
  _0: "PostalCode"
}, {
  TAG: "StringNotEmpty",
  _0: "City"
}, {
  TAG: "StringNotEmpty",
  _0: "IbanNumber"
}, {
  TAG: "CustomString",
  _0: "IbanNumber",
  _1: (value, param) => {
    if (CorporateEntity.Iban.validate(value)) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("The IBAN number is not valid.")
      };
    }
  }
}, {
  TAG: "CustomString",
  _0: "LegalRepresentative",
  _1: (value, param) => {
    if (value.length < 3) {
      return {
        TAG: "Error",
        _0: I18n.t("The legal representative is not valid, full name must be given.")
      };
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
}, {
  TAG: "CustomString",
  _0: "SiretNumber",
  _1: (value, values) => {
    let match = values.frenchCompany;
    let match$1 = values.country;
    if (match) {
      if (CompanyLegalNumber.French.isValidSiret(value)) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("siret_input_field.error_message")
        };
      }
    } else if (match$1 === "BE" && value !== "" && !CompanyLegalNumber.Belgian.isValidBce(value)) {
      return {
        TAG: "Error",
        _0: I18n.t("The BCE number must contain 10 digits.")
      };
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
}, {
  TAG: "CustomString",
  _0: "VatNumber",
  _1: (value, values) => {
    let match = values.country;
    if (value === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else if (match === "BE") {
      if (CompanyLegalNumber.Belgian.isValidVatNumber(value)) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("The VAT number is not valid.")
        };
      }
    } else if (CompanyLegalNumber.Vat.isValid(value)) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("The VAT number is not valid.")
      };
    }
  }
}];
let imageUri = Wino_logoPng;
let imageSize = "40px";
let styles = {
  image: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "height-kZKoxP": "height-x1vqgdyp",
    "width-kzqmXN": "width-x100vrsf",
    $$css: "wino-gc:src/app/Auth/AuthSignupPage.res.js:745"
  }
};
function AuthSignupPage$SignUpHeader(props) {
  let newrecord = {
    ...{
      className: "alignSelf-xamitd3 height-x1vqgdyp width-x100vrsf",
      "data-style-src": "wino-gc:src/app/Auth/AuthSignupPage.res.js:745"
    }
  };
  return JsxRuntime.jsxs(Inline.make, {
    children: [JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx("img", (newrecord.src = imageUri, newrecord)), JsxRuntime.jsx(Title.make, {
        children: I18n.t("Set Up Your Wino Account"),
        level: 1
      })],
      space: "medium",
      alignY: "center"
    }), JsxRuntime.jsx(SignupForm.SubmitButton.make, {
      label: I18n.t("Create your account"),
      tone: "success",
      size: "large",
      disabled: props.submitDisabled,
      onSubmitRequested: props.onSubmitRequested,
      onSubmit: props.onSubmit
    })],
    align: "spaceBetween"
  });
}
let SignUpHeader = {
  imageUri: imageUri,
  imageSize: imageSize,
  styles: styles,
  make: AuthSignupPage$SignUpHeader
};
let styles$1 = {
  container: {
    "maxWidth-ks0D6T": "maxWidth-x18d02x8",
    "paddingBottom-kGO01o": "paddingBottom-xo0ha1f",
    "paddingInline-kg3NbH": "paddingInline-xj7an9n",
    "paddingTop-kLKAdn": "paddingTop-x1p5oq8j",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/app/Auth/AuthSignupPage.res.js:788"
  }
};
function AuthSignupPage$SiretField(props) {
  let match = SignupForm.useField("SiretNumber", undefined, undefined, undefined, undefined);
  let onFocus = match.onFocus;
  return JsxRuntime.jsx(SiretInputField.make, {
    value: match.value,
    errored: Stdlib_Option.isSome(match.error),
    focused: match.focused,
    required: match.required,
    onChange: match.onChange,
    onCompanyFound: props.onCompanyFound,
    onFocus: () => onFocus(),
    onBlur: match.onBlur
  });
}
let SiretField = {
  make: AuthSignupPage$SiretField
};
function AuthSignupPage$CompanySearchField(props) {
  let dispatch = SignupForm.useFormDispatch();
  let match = React.useState(() => "");
  let setQuery = match[1];
  let onCompanySelected = company => {
    let legalRepresentative = [company.directorFirstName, company.directorLastName].filter(name => name !== "").join(" ");
    dispatch({
      TAG: "FieldValueChanged",
      _0: "CorporateName",
      _1: param => company.corporateName
    });
    [["SiretNumber", company.siret], ["VatNumber", company.vatNumber], ["LegalRepresentative", legalRepresentative], ["Address", company.street], ["PostalCode", company.postalCode], ["City", company.city]].forEach(param => {
      let value = param[1];
      if (value !== "") {
        return dispatch({
          TAG: "FieldValueChanged",
          _0: param[0],
          _1: param => value
        });
      }
    });
  };
  return JsxRuntime.jsx(CompanyComboBoxField.make, {
    label: I18n.t("Search your company"),
    companyName: match[0],
    onInputChange: value => setQuery(param => value),
    onRequestAutoComplete: onCompanySelected
  });
}
let CompanySearchField = {
  make: AuthSignupPage$CompanySearchField
};
function AuthSignupPage(props) {
  let __initialUsername = props.initialUsername;
  let initialNotification = props.initialNotification;
  let ipAddressRequest = props.ipAddressRequest;
  let signupRequest = props.signupRequest;
  let initialUsername = __initialUsername !== undefined ? __initialUsername : "";
  let navigate = Navigation.useNavigate();
  let containerRef = React.useRef(null);
  let scrollToTop = () => Stdlib_Option.forEach(ReactDomElement.fromRef(containerRef), ScrollHelpers.scrollAncestorsToTop);
  let match = React.useState(() => initialNotification);
  let setNotfication = match[1];
  let notification = match[0];
  let onSubmitSuccess = param => navigate(undefined, AuthRoutes.signupSuccess);
  let onSubmitFailure = error => {
    Stdlib_Option.forEach(ReactDomElement.fromRef(containerRef), ScrollHelpers.scrollAncestorsToTop);
    setNotfication(param => ({
      TAG: "Error",
      _0: error
    }));
  };
  let formPropState = SignupForm.useFormPropState({
    initialValues: {
      username: initialUsername,
      password: "",
      passwordConfirmation: "",
      name: "",
      email: "",
      phoneNumber: "",
      kind: "INDEPENDENT",
      frenchCompany: true,
      corporateName: "",
      legalRepresentative: "",
      legalForm: "",
      employeesNumber: undefined,
      taxationRegime: undefined,
      fiscalYearEndClosingMonth: undefined,
      website: "",
      amountOfShareCapital: undefined,
      siretNumber: "",
      rcsNumber: "",
      apeNafCode: "",
      vatNumber: "",
      address: "",
      city: "",
      postalCode: "",
      country: "FR",
      bankName: "",
      bankCode: "",
      bankAccountHolder: "",
      bankAccountNumber: "",
      bicCode: "",
      ibanNumber: ""
    },
    schema: schema,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let formState = formPropState[0];
  let validation = formState.validation;
  let submission = formState.submission;
  let values = formState.values;
  let formDispatch = formPropState[1];
  let submitting = Form__Submission.isRequested(submission);
  let match$1 = React.useState(() => false);
  let setSiretNumberNotFound = match$1[1];
  let match$2 = React.useState(() => {});
  let setLegalForm = match$2[1];
  let legalForm = match$2[0];
  React.useEffect(() => {
    setSiretNumberNotFound(param => false);
    setLegalForm(param => {});
  }, [values.siretNumber]);
  let onCompanyFound = lookup => {
    if (lookup !== undefined) {
      let company = lookup.company;
      let legalForm = lookup.legalForm;
      setSiretNumberNotFound(param => false);
      setLegalForm(param => legalForm);
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "CorporateName",
        _1: param => company.corporateName
      });
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "VatNumber",
        _1: param => company.vatNumber
      });
      return formDispatch({
        TAG: "FieldValueChanged",
        _0: "ApeNafCode",
        _1: param => company.apeNafCode
      });
    }
    setSiretNumberNotFound(param => true);
    setLegalForm(param => {});
  };
  let privacyRight = typeof legalForm === "object" ? legalForm.privacyRight : false;
  let submitDisabled = values.frenchCompany && match$1[0];
  React.useEffect(() => {
    if (submitting) {
      setNotfication(param => {});
    }
  }, [submitting]);
  let onSubmit = (param, param$1) => {
    let ibanNumber = param$1.ibanNumber;
    let bicCode = param$1.bicCode;
    let bankAccountNumber = param$1.bankAccountNumber;
    let bankAccountHolder = param$1.bankAccountHolder;
    let bankCode = param$1.bankCode;
    let bankName = param$1.bankName;
    let country = param$1.country;
    let postalCode = param$1.postalCode;
    let city = param$1.city;
    let address = param$1.address;
    let vatNumber = param$1.vatNumber;
    let apeNafCode = param$1.apeNafCode;
    let rcsNumber = param$1.rcsNumber;
    let siretNumber = param$1.siretNumber;
    let amountOfShareCapital = param$1.amountOfShareCapital;
    let website = param$1.website;
    let fiscalYearEndClosingMonth = param$1.fiscalYearEndClosingMonth;
    let taxationRegime = param$1.taxationRegime;
    let employeesNumber = param$1.employeesNumber;
    let legalForm = param$1.legalForm;
    let legalRepresentative = param$1.legalRepresentative;
    let corporateName = param$1.corporateName;
    let kind = param$1.kind;
    let phoneNumber = param$1.phoneNumber;
    let email = param$1.email;
    let name = param$1.name;
    let password = param$1.password;
    let username = param$1.username;
    return Future.mapError(Future.mapOk(Future.flatMap(Future.tapError(ipAddressRequest(), error => BugTracker.reportErrorMessage("Fetching IP on signup failed with error: " + Stdlib_Option.getOr(Json.stringifyAny(error), "unknown"))), undefined, ipRequestResult => {
      if (ipRequestResult.TAG === "Ok") {
        return signupRequest(username, password, name, email, phoneNumber, kind, corporateName, legalRepresentative, legalForm, siretNumber, rcsNumber, apeNafCode, CompanyLegalNumber.Vat.normalize(vatNumber), address, postalCode, city, country, website, Stdlib_Option.mapOr(amountOfShareCapital, "", CorporateEntity.ShareCapital.toString), Stdlib_Option.mapOr(fiscalYearEndClosingMonth, "", FiscalYearOpeningMonth.toLowercaseString), Stdlib_Option.mapOr(taxationRegime, "", ElectronicInvoicing.TaxationRegime.toRaw), Stdlib_Option.mapOr(employeesNumber, "", ElectronicInvoicing.EmployeesNumber.toRaw), bankName, bankCode, bankAccountHolder, bankAccountNumber, bicCode, CorporateEntity.Iban.sanitize(ibanNumber), ipRequestResult._0, UserAgent.get(), Date.now());
      } else {
        return Future.value({
          TAG: "Error",
          _0: "IpAddressFailure"
        });
      }
    }), undefined, () => I18n.t("Account successfully set up.")), undefined, failure => {
      if (failure === undefined) {
        return I18n.t("An unexpected error occured. Please try again or contact the support.");
      }
      switch (failure) {
        case "DuplicateUserUsername":
          return I18n.t("This email address is already used.");
        case "InvalidVatNumber":
          return I18n.t("The VAT number is not valid.");
        case "WrongSepaMandateAcceptanceDetails":
          return I18n.t("Your internet connection has been interrupted, please reload the page before submitting the form again.");
        case "InvalidIban":
          return I18n.t("The IBAN number is not valid.");
        case "InvalidCorporateName":
          return I18n.t("The corporate name is not valid, you must enter the name of your company.");
        case "IpAddressFailure":
        case "Unknown":
          return I18n.t("An unexpected error occured. Please try again or contact the support.");
      }
    });
  };
  let errorMessageAddress;
  errorMessageAddress = validation.TAG === "Ok" || typeof submission !== "object" || submission.TAG !== "Failed" ? undefined : Stdlib_Array.filterMap(validation._0, param => {
    if (param[0]._0 === "Address") {
      return param[1];
    }
  })[0];
  let onChangeAddress = value => formDispatch({
    TAG: "FieldValueChanged",
    _0: "Address",
    _1: param => value
  });
  let onRequestAddressAutoComplete = address => {
    formDispatch({
      TAG: "FieldValueChanged",
      _0: "Address",
      _1: param => address.name
    });
    formDispatch({
      TAG: "FieldValueChanged",
      _0: "PostalCode",
      _1: param => address.postcode
    });
    formDispatch({
      TAG: "FieldValueChanged",
      _0: "City",
      _1: param => address.city
    });
  };
  let match$3 = values.country;
  let rcsNumberLabel;
  switch (match$3) {
    case "BE":
      rcsNumberLabel = Placeholder.NA.text;
      break;
    case "LU":
      rcsNumberLabel = I18n.t("RCSL number");
      break;
    default:
      rcsNumberLabel = I18n.t("RCS number");
  }
  let match$4 = values.country;
  let rcsNumberPlaceholder;
  switch (match$4) {
    case "BE":
      rcsNumberPlaceholder = Placeholder.NA.text;
      break;
    case "LU":
      rcsNumberPlaceholder = I18n.t("B201345");
      break;
    default:
      rcsNumberPlaceholder = I18n.t("RCS Paris B 812345678");
  }
  let newrecord = {
    ...{
      className: "maxWidth-x18d02x8 paddingBottom-xo0ha1f paddingInline-xj7an9n paddingTop-x1p5oq8j width-xh8yej3",
      "data-style-src": "wino-gc:src/app/Auth/AuthSignupPage.res.js:788"
    }
  };
  newrecord.ref = Primitive_option.some(containerRef);
  let match$5 = values.frenchCompany;
  let match$6 = values.country;
  let tmp;
  tmp = match$5 ? JsxRuntime.jsx(AuthSignupPage$SiretField, {
    onCompanyFound: onCompanyFound
  }) : match$6 === "BE" ? JsxRuntime.jsx(SignupForm.InputText.make, {
    field: "SiretNumber",
    label: I18n.t("BCE number"),
    placeholder: I18n.t("Enter 10 digits"),
    hideRequired: true
  }) : null;
  let match$7 = values.country;
  let tmp$1;
  tmp$1 = match$7 === "BE" ? null : JsxRuntime.jsx(SignupForm.InputText.make, {
    field: "RcsNumber",
    label: rcsNumberLabel,
    placeholder: rcsNumberPlaceholder
  });
  let month = values.fiscalYearEndClosingMonth;
  let tmp$2;
  if (month !== undefined) {
    let match$8 = FiscalYearOpeningMonth.currentFiscalYearPeriod(undefined, month);
    tmp$2 = JsxRuntime.jsxs(NextBanner.make, {
      children: [JsxRuntime.jsx(NextBanner.Text.make, {
        text: I18n.t("Current fiscal year:") + " "
      }), JsxRuntime.jsx(NextBanner.Text.make, {
        text: I18n.template(I18n.t("from {{startDate}} to {{endDate}}"), {
          startDate: DateHelpers.formateToMediumDate(match$8[0]),
          endDate: DateHelpers.formateToMediumDate(match$8[1])
        }, undefined),
        bold: true
      })],
      variation: "info",
      compact: true
    });
  } else {
    tmp$2 = null;
  }
  newrecord.children = [JsxRuntime.jsx(SpinnerModal.make, {
    title: I18n.t("Account creation"),
    opened: submitting,
    loopMessages: [I18n.t("User account creation"), I18n.t("Subscription setup"), I18n.t("Tax creation"), I18n.t("Configuring devices"), I18n.t("Validating your payment method")]
  }), JsxRuntime.jsx(AuthSignupPage$SignUpHeader, {
    submitDisabled: submitDisabled,
    onSubmitRequested: scrollToTop,
    onSubmit: onSubmit
  }), notification !== undefined ? JsxRuntime.jsx(make$1, {
    notification: notification
  }) : null, JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
          title: I18n.t("Login details"),
          description: I18n.t("Please make a note of your password out of sight. This will solve a potential slight memory lapse when first logging into Wino!"),
          space: "xlarge",
          padding: "xxlarge",
          children: [JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "Username",
            label: I18n.t("Account email"),
            placeholder: I18n.t("anna.rossi@gmail.com")
          }), JsxRuntime.jsx(SignupForm.InputPassword.make, {
            field: "Password",
            label: I18n.t("Password"),
            placeholder: I18n.t("Password"),
            showTypingValidation: true
          }), JsxRuntime.jsx(SignupForm.InputPassword.make, {
            field: "PasswordConfirmation",
            label: I18n.t("Password confirmation"),
            placeholder: I18n.t("Password confirmation"),
            hideRequired: true
          })]
        }), JsxRuntime.jsx(CanarySeparator.make, {
          orientation: "horizontal"
        }), JsxRuntime.jsx(FieldsetLayoutPanel.make, {
          title: I18n.t("Shop type"),
          space: "xlarge",
          padding: "xxlarge",
          children: JsxRuntime.jsx(SignupForm.InputToggleButtonGroup.make, {
            field: "Kind",
            items: Auth__Types.ShopKind.values.map(kind => ({
              key: Auth__Types.ShopKind.toString(kind),
              label: Auth__Types.ShopKind.toLabel(kind),
              value: kind
            })),
            grow: true,
            hideRequired: true
          })
        }), JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
          title: I18n.t("General store information"),
          description: I18n.t("Complete the store name and your contact information that will be displayed on your sales documents."),
          space: "xlarge",
          padding: "xxlarge",
          children: [JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "Name",
            label: I18n.t("Shop name"),
            placeholder: I18n.t("Shop name")
          }), JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "Email",
            label: I18n.t("Shop email address"),
            placeholder: I18n.t("contact@shop.com")
          }), JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "PhoneNumber",
            label: I18n.t("Shop phone"),
            placeholder: I18n.t("01 23 45 67 89")
          }), JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "Website",
            label: I18n.t("Shop website"),
            placeholder: "www.boutique.com"
          })]
        })],
        space: "xlarge"
      }), JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
        title: I18n.t("Company information"),
        description: I18n.t("These details will be used for billing our services. They will also appear on your sales documents issued by the Wino software."),
        children: [JsxRuntime.jsxs(FieldsetLayoutPanel.Section.make, {
          accent: true,
          space: "xlarge",
          padding: "xxlarge",
          children: [JsxRuntime.jsx(SignupForm.InputToggleButtonGroup.make, {
            field: "FrenchCompany",
            items: [{
              key: "france",
              label: I18n.t("France"),
              value: true
            }, {
              key: "other",
              label: I18n.t("Other country"),
              value: false
            }],
            grow: true,
            hideRequired: true
          }), values.frenchCompany ? JsxRuntime.jsx(AuthSignupPage$CompanySearchField, {}) : null]
        }), JsxRuntime.jsxs(FieldsetLayoutPanel.Section.make, {
          title: I18n.t("Legal information"),
          space: "xlarge",
          padding: "xxlarge",
          children: [JsxRuntime.jsxs(Group.make, {
            children: [JsxRuntime.jsx(SignupForm.InputText.make, {
              field: "CorporateName",
              label: I18n.t("Corporate name"),
              placeholder: values.frenchCompany ? I18n.t("Search your company to fill in") : I18n.t("Company name as displayed on your official business registration document."),
              disabled: values.frenchCompany && !privacyRight
            }), JsxRuntime.jsx(SignupForm.InputSuggestionComboBox.make, {
              field: "LegalForm",
              label: I18n.t("Legal form"),
              placeholder: I18n.t("Legal form"),
              items: CorporateEntity.CompanyLegalForm.values.map(value => ({
                value: I18n.t(CorporateEntity.CompanyLegalForm.toString(value))
              }))
            })],
            spaceX: "xlarge",
            spaceY: "xlarge"
          }), JsxRuntime.jsx(SiretInputField.LegalFormBanner.make, {
            legalForm: legalForm
          }), JsxRuntime.jsxs(Group.make, {
            children: [JsxRuntime.jsx(SignupForm.InputText.make, {
              field: "LegalRepresentative",
              label: I18n.t("Legal representative"),
              placeholder: I18n.t("Anna Rossi")
            }), JsxRuntime.jsx(SignupForm.InputSelect.make, {
              field: "EmployeesNumber",
              label: I18n.t("Employees number"),
              placeholder: I18n.t("Select a number of employees"),
              sections: ElectronicInvoicing.EmployeesNumber.selectSections
            })],
            spaceX: "xlarge",
            spaceY: "xlarge"
          }), JsxRuntime.jsxs(Group.make, {
            children: [JsxRuntime.jsx(SignupForm.InputOptionalNumber.make, {
              field: "AmountOfShareCapital",
              label: I18n.t("Amount of share capital"),
              hideStepper: true,
              placeholder: "10 000,00",
              appender: {
                TAG: "Currency",
                _0: "EUR"
              },
              minValue: 0
            }), JsxRuntime.jsx(SignupForm.InputText.make, {
              field: "ApeNafCode",
              label: I18n.t("APE/NAF code"),
              placeholder: I18n.t("Enter a code of 4 digits and one letter")
            })],
            spaceX: "xlarge",
            spaceY: "xlarge"
          })]
        }), JsxRuntime.jsxs(FieldsetLayoutPanel.Section.make, {
          title: I18n.t("Legal and tax identification"),
          space: "xlarge",
          padding: "xxlarge",
          children: [JsxRuntime.jsxs(Group.make, {
            children: [tmp, JsxRuntime.jsx(SignupForm.InputText.make, {
              field: "VatNumber",
              label: I18n.t("VAT number"),
              placeholder: I18n.t("FR 11 123123123"),
              hideRequired: true
            })],
            spaceX: "xlarge",
            spaceY: "xlarge"
          }), tmp$1]
        }), JsxRuntime.jsx(FieldsetLayoutPanel.Section.make, {
          title: I18n.t("Other tax information"),
          space: "xlarge",
          padding: "xxlarge",
          children: JsxRuntime.jsxs(Group.make, {
            children: [JsxRuntime.jsx(SignupForm.InputSelect.make, {
              field: "TaxationRegime",
              label: I18n.t("settings_electronic_invoicing_page.account_creation_modal.form.taxation_regime.label"),
              placeholder: I18n.t("settings_electronic_invoicing_page.account_creation_modal.form.taxation_regime.placeholder"),
              sections: ElectronicInvoicing.TaxationRegime.selectSections
            }), JsxRuntime.jsxs(Stack.make, {
              children: [JsxRuntime.jsx(SignupForm.InputSelect.make, {
                field: "FiscalYearEndClosingMonth",
                label: I18n.t("Fiscal year end closing month"),
                tooltip: JsxRuntime.jsx(Tooltip.Span.make, {
                  text: I18n.t("This setting will automatically be taken into account when creating your next annual Z, to ensure correct calculations over the reference period.")
                }),
                placeholder: I18n.t("Select a month"),
                sections: [{
                  items: FiscalYearOpeningMonth.values.map(month => ({
                    TAG: "Option",
                    key: month,
                    label: I18n.t(month),
                    value: month
                  }))
                }]
              }), tmp$2],
              space: "small"
            })],
            spaceX: "xlarge",
            spaceY: "xlarge"
          })
        })]
      }), JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
        title: I18n.t("Billing address"),
        description: I18n.t("This address will be used for billing our services. It will also appear on your sales documents issued by the Wino software. If needed, it can be changed later within the software."),
        space: "xlarge",
        padding: "xxlarge",
        children: [JsxRuntime.jsx(AddressComboBoxField.make, {
          errorMessage: errorMessageAddress,
          required: true,
          addressName: values.address,
          onInputChange: onChangeAddress,
          onRequestAutoComplete: onRequestAddressAutoComplete
        }), JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "PostalCode",
            label: I18n.t("Postal code"),
            placeholder: I18n.t("Postal code")
          }), JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "City",
            label: I18n.t("City"),
            placeholder: I18n.t("City")
          })],
          spaceX: "xlarge",
          spaceY: "xlarge"
        }), JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(SignupForm.InputSelect.make, {
            field: "Country",
            label: I18n.t("Country"),
            sections: [{
              items: CountryCode.values.map(value => ({
                TAG: "Option",
                key: CountryCode.toIso2String(value),
                label: I18n.t(CountryCode.toLongCountryString(value)),
                value: value
              }))
            }]
          }), JsxRuntime.jsx(NextBanner.make, {
            children: JsxRuntime.jsx(NextBanner.Text.make, {
              text: I18n.t("For your country, carefully select the proposal corresponding to your situation. Your choice will determine the VAT settings on your account.")
            }),
            variation: "important",
            compact: true
          })],
          space: "small"
        })]
      }), JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
        title: I18n.t("Banking information"),
        description: I18n.t("Enter your banking information. It will be shared with your customers for invoicing."),
        space: "xlarge",
        padding: "xxlarge",
        children: [JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "BankName",
            label: I18n.t("Bank name"),
            placeholder: "CIC"
          }), JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "BankCode",
            label: I18n.t("Bank code"),
            placeholder: "10057"
          })],
          spaceX: "xlarge",
          spaceY: "xlarge"
        }), JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "BankAccountHolder",
            label: I18n.t("Bank account holder"),
            placeholder: "Jean Martin"
          }), JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "BankAccountNumber",
            label: I18n.t("Bank account number"),
            placeholder: "01888457589"
          })],
          spaceX: "xlarge",
          spaceY: "xlarge"
        }), JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "IbanNumber",
            label: I18n.t("IBAN number"),
            placeholder: "FR14 2004 1010 0505 0001 3M02 606"
          }), JsxRuntime.jsx(SignupForm.InputText.make, {
            field: "BicCode",
            label: I18n.t("BIC code"),
            placeholder: "CMCIFTPP"
          })],
          spaceX: "xlarge",
          spaceY: "xlarge"
        })]
      })],
      space: "xxlarge"
    }),
    spaceTop: "huge"
  }), JsxRuntime.jsx(PageBottomActionsBar.make, {
    displayThreshold: 180,
    renderStart: () => JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(Button.make, {
        ariaLabel: I18n.t("Help center"),
        icon: "help_center",
        tooltipText: I18n.t("Help center"),
        onPress: () => HelpCenter.showHelp()
      }), JsxRuntime.jsx(Button.make, {
        label: I18n.t("Contact support"),
        onPress: () => HelpCenter.showMessages()
      })],
      space: "small"
    }),
    renderEnd: () => JsxRuntime.jsx(SignupForm.SubmitButton.make, {
      label: I18n.t("Create your account"),
      tone: "success",
      disabled: submitDisabled,
      onSubmitRequested: scrollToTop,
      onSubmit: onSubmit
    })
  })];
  return JsxRuntime.jsx(SignupForm.Core.Provider.make, {
    children: JsxRuntime.jsxs("div", newrecord),
    propState: formPropState
  });
}
let signupRequest = make;
let make$2 = AuthSignupPage;
export { SignupFormLenses_, SignupFormLenses, SignupForm, stripEmptyString, SignupRequest, signupRequest, NotificationBanner, schema, SignUpHeader, styles$1 as styles, SiretField, CompanySearchField, make$2 as make };
/* SignupForm Not a pure module */